export default "__VITE_ASSET__Bm_qqq7t__"